@if (viewModel) {
  <div>
    <div>
      <rask-input class="col-2" label="BYL" value="{{viewModel.byl}}" [readonly]="true"></rask-input>
      <rask-input class="col-2" label="HA" value="{{viewModel.hektar}}" [readonly]="true"></rask-input>
      <rask-input class="col-2" label="M3F" value="{{viewModel.uttagm3fub}}" [readonly]="true"></rask-input>
    </div>
    @if (viewModel.tradslagsdata) {
      <rask-header size="4">Trädslagsdata - bestånd före avverkning</rask-header>
    }
    @if (!viewModel.tradslagsdata && isEnabledForSelection) {
      <rask-header size="4">- Data saknas i GISS.</rask-header>
    }
    @if (viewModel.tradslagsdata) {
      <rask-table
        [data]="viewModel.tradslagsdata"
        [columns]="viewModel.tradslagsdataColumns">
      </rask-table>
    }
    @if (viewModel.hasTradslagsdataBeraknatUttag) {
      <rask-header size="4">Trädslagsdata - beräknat uttag</rask-header>
    }
    @if (!viewModel.hasTradslagsdataBeraknatUttag && isEnabledForSelection) {
      <rask-header size="4">- Data saknas i GISS.</rask-header>
    }
    @if (viewModel.tradslagsdataBeraknatUttag) {
      <rask-table
        [data]="viewModel.tradslagsdataBeraknatUttag"
        [columns]="viewModel.tradslagsdataBeraknatUttagColumns">
      </rask-table>
    }
  </div>
}
